// @ts-nocheck
import { Component, OnInit, Input } from '@angular/core';
import { P } from '../../ui-kit';

@Component({
  selector: 'lib-price-category',
  templateUrl: './price-category.component.html',
  styleUrls: ['./price-category.component.scss'],
})
export class PriceCategoryComponent implements OnInit {
  toggle: P.Dictionary<boolean> = {};

  tooltipOptions: P.Dictionary<P.CategoryType> = {
    'Fair price': 'This property is in line with our data-science driven benchmark for true value in the area.',
    'Great price': 'We give this one two thumbs up. This property is valued 10% under the fair-value in the area.',
    'Hidden gem': 'A diamond in the rough! This property is a great deal and discounted.',
    'Over valued': 'This property is valued over the fair-value in the area.',
  };

  @Input() category: P.CategoryType;

  @Input() metadata: Partial<P.ListingMetadata>;

  price: number;

  priceChangeSinceListedPercent: number;

  ppsqmOffset: number;

  categoryAlias: string;

  offsetLabel: string;

  offsetValue: number;

  offsetValuePercent: number;

  constructor() {}

  ngOnChanges(): void {
    if (!this.metadata) {
      this.toggle.hidden = true;
      return;
    }

    this.categoryAlias = this.category
      ? this.category
        .toLowerCase()
        .replace(' ', '-')
      : null;

    this.price = this.metadata?.price;
    this.priceChangeSinceListedPercent = this.metadata?.price_change_since_listed_pct;

    switch (this.category) {
      case 'Over valued':
        this.ppsqmOffset = this.sanitizePpsqmOffset(this.metadata?.price_offset);
        this.offsetLabel = '';
        this.offsetValuePercent = this.ppsqmOffset;
        this.offsetValue = this.price * this.ppsqmOffset;
        break;
      case 'Fair price':
      case 'Good price':
      case 'Great price':
      case 'Rare find':
      case 'Hidden gem':
      default:
        this.ppsqmOffset = this.sanitizePpsqmOffset(-this.metadata?.price_offset);
        this.offsetLabel = 'Under valued';
        this.offsetValuePercent = this.ppsqmOffset;
        this.offsetValue = this.price * this.ppsqmOffset;
        break;
    }

    this.toggle.hidden = false;
  }

  private sanitizePpsqmOffset(ppsqmOffset: number): number {
    const maxPpsqmOffset = 0.25;

    if (ppsqmOffset > maxPpsqmOffset) {
      ppsqmOffset = maxPpsqmOffset;
    }

    return ppsqmOffset;
  }
}
